<soft-resource-container [resource]="fattenerService">
  <lib-fattener-info [fattener]="fattener()"></lib-fattener-info>
</soft-resource-container>
<soft-resource-container [resource]="stableService">
  <lib-report-form></lib-report-form>
</soft-resource-container>

